<div *ngIf="selectedEventTicket$ | async as eventTicket" class="gb-event-ticket-edit-guest-dialog">
  <mat-toolbar role="toolbar" class="gb-dialog-header">
    <h2 [translate]="title" mat-dialog-title></h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-dialog-content>
    <p
      *ngIf="isCheckIn"
      translate="SHARED.EVENT_TICKETS.EDIT_GUEST.CHECK_IN_INFO"
      [translateParams]="{ name: eventTicket.profile | gbDisplayName }"
    ></p>

    <gb-event-ticket-guest-form
      [eventTicket]="eventTicket"
      [shouldShowSelfAssign]="false"
      [isCheckIn]="isCheckIn"
      (onSelfAssignedChange)="isSelfAssigned = $event"
      (formReady)="guestForm = $event"
    ></gb-event-ticket-guest-form>

    <div *ngIf="hasCustomFields(eventTicket)">
      <gb-event-ticket-questions-form
        [customFields$]="selectedEventTicketCustomFields$"
        [customValues$]="selectedEventTicketCustomValues$"
        [shouldPrepopulateForm]="true"
        [allOptional]="!isSelfAssigned || isAdminOrVolunteer"
        (formReady)="questionsForm = $event"
      ></gb-event-ticket-questions-form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <ng-container *ngIf="shouldShowSubmit(eventTicket); else viewOnly">
      <button mat-stroked-button mat-dialog-close type="button" translate="CANCEL"></button>
      <button mat-raised-button color="primary" type="submit" (click)="onSubmit()">
        <span [translate]="buttonLabel"></span>
      </button>
    </ng-container>

    <ng-template #viewOnly>
      <button mat-stroked-button mat-dialog-close type="button" translate="CLOSE"></button>
    </ng-template>
  </mat-dialog-actions>
</div>
